import { useState } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ModalMap } from '../tabs/ModalMap';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const LocationDateComponent = ({ field }) => {
  const [isOpenMapModal, setIsOpenMapModel] = useState(false);
  const { translate: t } = useDictionaryTranslation();
  const formatDate = (date) => date && moment(date).format('dddd DD MMMM YYYY (HH:mm:ss)');

  const openMapModal = () => {
    setIsOpenMapModel(true);
  };
  const closeMapModal = () => {
    setIsOpenMapModel(false);
  };

  return (
    <>
      <p>
        {formatDate(field?.value?.time ?? field?.value?.timestamp)} -{' '}
        <Button style={{ padding: 0 }} type="link" onClick={openMapModal}>
          {' '}
          {t('showLocation')}
        </Button>
      </p>
      <ModalMap
        title={field.label}
        show={isOpenMapModal}
        handleClose={closeMapModal}
        coordsInfo={{
          value: {
            markerCoords: field?.value?.coords ?? field?.value?.markerCoords,
          },
        }}
      />
    </>
  );
};

LocationDateComponent.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.shape({
      time: PropTypes.string,
      markerCoords: PropTypes.string,
      timestamp: PropTypes.string,
      coords: PropTypes.string,
    }),
  }),
};
